import maplibregl from 'maplibre-gl';

/*  Exports
    ======================================================================================= */
function resizeMap(map) {
  const nw = map.getBounds().getNorthWest();
  map.resize();
  const newNw = map.getBounds().getNorthWest();
  const shiftVector = { x: (newNw.lng - nw.lng), y: (newNw.lat - nw.lat) };

  const center = map.getCenter();
  const newCenter = new maplibregl.LngLat(center.lng - shiftVector.x, center.lat - shiftVector.y);
  map.setCenter(newCenter); // prevents panning
}
let malawiGeoJsonPromise;

function isPointOnSegment(px, py, x1, y1, x2, y2, epsilon = 1e-10) {
  const cross = (py - y1) * (x2 - x1) - (px - x1) * (y2 - y1);
  if (Math.abs(cross) > epsilon) return false;

  const dot = (px - x1) * (px - x2) + (py - y1) * (py - y2);
  return dot <= epsilon;
}

function isPointInRing(pointLng, pointLat, ring) {
  let inside = false;

  for (let i = 0, j = ring.length - 1; i < ring.length; j = i, i += 1) {
    const [xi, yi] = ring[i];
    const [xj, yj] = ring[j];

    if (isPointOnSegment(pointLng, pointLat, xi, yi, xj, yj)) {
      return true;
    }

    const intersects = ((yi > pointLat) !== (yj > pointLat))
      && (pointLng < ((xj - xi) * (pointLat - yi)) / (yj - yi) + xi);

    if (intersects) {
      inside = !inside;
    }
  }

  return inside;
}

function isPointInPolygon(pointLng, pointLat, polygonCoordinates) {
  const [outerRing, ...holes] = polygonCoordinates;
  if (!outerRing || !isPointInRing(pointLng, pointLat, outerRing)) {
    return false;
  }

  return !holes.some(hole => isPointInRing(pointLng, pointLat, hole));
}

function isPointInGeometry(pointLng, pointLat, geometry) {
  if (!geometry) return false;

  if (geometry.type === 'Polygon') {
    return isPointInPolygon(pointLng, pointLat, geometry.coordinates);
  }

  if (geometry.type === 'MultiPolygon') {
    return geometry.coordinates.some(polygon => isPointInPolygon(pointLng, pointLat, polygon));
  }

  return false;
}

async function getMalawiBoundariesGeoJson() {
  if (!malawiGeoJsonPromise) {
    malawiGeoJsonPromise = fetch('/malawi_regions.geojson')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to load Malawi boundaries.');
        }

        return response.json();
      });
  }

  return malawiGeoJsonPromise;
}

async function isPointWithinMalawi(lat, lng) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return false;
  }

  try {
    const geoJson = await getMalawiBoundariesGeoJson();
    const { features = [] } = geoJson || {};

    return features.some(feature => isPointInGeometry(lng, lat, feature.geometry));
  } catch (error) {
    console.error(error);
    return false;
  }
}

export {
  resizeMap, 
  isPointWithinMalawi, 
}